import React from "react";

function ContactAbout() {
    return (
        <div className="ContactAbout">
            <div className='contacttext'>
                I love working with talented artists and singers and this is my favourite way to write new songs.
                <br></br>
                <br></br>
                It’s all about getting together and creating something greater than your individual ideas, and as a creative I live for those special moments during a co-write when you are onto a great idea or an addictive melody.
                <br></br>
                <br></br>
                As part of that creative process I can also help you identify your signature strengths and writing styles, and provide some creative direction.
            </div>
        </div>
    );
}

export default ContactAbout;